var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';
import { buildClassnames } from './templates/header-elements/header-region';
var HeaderLogoSizes;
(function (HeaderLogoSizes) {
    HeaderLogoSizes["XSMALL"] = "extra-small-logo";
    HeaderLogoSizes["SMALL"] = "small-logo";
    HeaderLogoSizes["LARGE"] = "large-logo";
})(HeaderLogoSizes || (HeaderLogoSizes = {}));
var HeaderLogo = function (_a) {
    var logoUrl = _a.logoUrl, logoAltText = _a.logoAltText, logoHref = _a.logoHref, logoSize = _a.logoSize, classes = _a.classes;
    if (!logoUrl || !logoAltText) {
        return null;
    }
    return (React.createElement(UitkSpacing, { padding: { inlineend: 'six', block: 'two' } },
        React.createElement("a", { href: logoHref || '/', className: buildClassnames('header-logo', classes) },
            React.createElement("img", __assign({ src: logoUrl, alt: logoAltText }, (logoSize ? { className: logoSize } : {}))))));
};
export { HeaderLogo, HeaderLogoSizes };
//# sourceMappingURL=header-logo.js.map